'use strict';var _ = require('lodash');
var validator = require('./../validator');
var parser = require('./../parser');
var constants = require('./../constants');
var VARIABLE_TOKEN_MATCH = constants.VARIABLE_TOKEN_REGEX;

/**
                                                            * Replaces our tokens with the values from the context.
                                                            * @param  {String} expression An expression string to compile
                                                            * @param  {Object} context    The context variables for the expression
                                                            * @return {String}            A compiled expression ready to be run through the parser
                                                            */
function replaceTokens(expression, context) {
  var compiled = _.cloneDeep(expression);
  var matches = compiled.match(VARIABLE_TOKEN_MATCH);

  function substitute(token) {
    return '(' + context[token.substring(2, token.length - 1)] + ')';
  }

  while (matches) {
    compiled = compiled.replace(VARIABLE_TOKEN_MATCH, substitute);
    matches = compiled.match(VARIABLE_TOKEN_MATCH);
  }

  return compiled;
}

/**
   * Compiles and parses and expression with a given context.
   * @param  {String} expression A string representation of the expression to be evaluated.
   * @param  {Object} context    An object containing the values for the variables in the expression.
   * @return {Number}            The result of the expression.
   */
function parseExpression(expression, context) {
  var compiledExpression = replaceTokens(expression, context);
  return parser.parse(compiledExpression);
}

/**
   * Takes an expression and a context and evaluates the expression into a value.
   * @param  {String} expression A string representation of the expression to be evaluated.
   * @param  {Object} context    An object containing the values for the variables in the expression.
   * @return {Number}            The value resulting from the evaluation of the expression.
   */
module.exports.evaluate = function (expression, context) {
  validator.validate(expression, context);
  return parseExpression(expression, context);
};

/**
    * Evaluates an array of expressions with a single context
    * @param  {[String]} expressions An array of strings representing
    * @param  {Object} context     An object containing the values for the variables in the expressions
    * @return {Object}             Returns an array of validation responses
    */
module.exports.evaluateBatch = function (expressions, context) {
  return _.map(validator.validateBatch(expressions, context),
  function (validationResponse) {
    if (validationResponse.isValid) {
      validationResponse.value = parseExpression(validationResponse.key, context);
    }
    return validationResponse;
  });
};